import React from 'react';
import { useLARequirements } from '@/features/applications/faculty/CreateApplicationSection3';
import { formatWindowDate } from '@/shared/utils/deadline';

const QUALIFIER = { new: 'new LAs: ', returning: 'returning LAs: ' };

/**
 * Stands in for the expected time and the journal while the term has not started: the start
 * date and, for an LA, the program's dated trainings to attend first. A
 * training that applies to new or returning LAs only says so, since an
 * assignment does not record which the student is.
 */
function AssignmentStartNote({ assignment, startDate }) {
    const isLa = assignment.programType === 'la';
    const { requirements } = useLARequirements(assignment.term, isLa);
    const sessions = requirements?.trainingSessions || [];

    return (
        <div role="note" className="mb-3">
            <p className="fw-semibold mb-1">
                Starts {formatWindowDate(startDate)}.
            </p>
            {sessions.length > 0 && (
                <>
                    <p className="mb-1">Before then:</p>
                    <ul className="small mb-0">
                        {sessions.map(({ title, when, appliesTo }) => (
                            <li key={`${title}-${when}`}>
                                {QUALIFIER[appliesTo] || ''}
                                {title}, {when}
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
}

export default AssignmentStartNote;
